<template>
  <div
    ref="MenuItem"
    :class="`MenuItem ${showSubMenus?'Selected':''}`"
    @mouseenter="toggleSubmenus(true)"
    @mouseleave="toggleSubmenus(false)"
  >
    <div
      class="IconMenu"
      @click="selectHandle"
    >
      <div class="IconMenu-icon">
        <slot name="icon">
          <img src="@/assets/images/layout/icon_huiyuanguanli@2x.png" />
        </slot>
      </div>
      <div class="IconMenu-name">{{ menuName}}</div>
    </div>
    <div
      :class="{SubmenuBox: true, show: showSubMenus, scroll: needScroll}"
      :style="style"
      v-if="menuList && menuList.length"
    >
      <template v-if="noTitle">
        <div class="Submenu">
          <div class="Submenu-list">
            <div
              class="Submenu-link"
              v-for="(item, index) in menuList"
              :key="index"
            >
              <LikeIcon :name="item.name" />
              <router-link
                class="Submenu-link-text"
                :to="item.path"
              >{{item.meta.title}}</router-link>
            </div>
          </div>
        </div>
      </template>
      <template v-else>

        <div
          class="Submenu"
          v-for="(item, index) in menuList"
          :key="index"
        >
          <div class="Submenu-title">
            <span>{{item.meta.title}}</span>
            <LikeIcon
              v-if="!item.children"
              :name="item.name"
            />
          </div>
          <div
            class="Submenu-list"
            v-if="item.children && item.children.length"
          >
            <div
              class="Submenu-link"
              v-for="(item, index) in item.children"
              :key="index"
            >
              <LikeIcon :name="item.name" />
              <router-link
                class="Submenu-link-text"
                :to="item.path"
              >{{item.meta.title}}</router-link>
            </div>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import LikeIcon from './LikeIcon';

let timers = null;
export default {
  name: 'MenuItem',
  components: { LikeIcon },
  props: {
    menuName: {
      type: String,
      default: '',
    },
    menuList: {
      type: Array,
      default: () => [],
    },
    selectRouteMenu: {
      type: Function,
    },
    noTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSubMenus: false,
      needScroll: false,
      style: '',
    };
  },
  mounted() {
    let dom = this.$refs.MenuItem;
    let offsetRight = document.body.offsetWidth - dom.offsetLeft;
    if (offsetRight < 390) {
      this.style = 'right: 0;';
    } else if (offsetRight < 560) {
      this.style = 'right: -280px;';
    } else {
      this.style = 'left: 0;';
    }
  },
  watch: {
    $route() {
      this.toggleSubmenus(false);
    },
  },
  methods: {
    toggleSubmenus(visiable) {
      this.showSubMenus = visiable;
      if (visiable) {
        // this.$nextTick(() => {
        // });
        timers = setTimeout(() => {
          this.needScroll = visiable;
        }, 280);
      } else {
        if (timers) {
          clearTimeout(timers);
          timers = null;
        }
        this.needScroll = visiable;
      }
    },
    selectHandle() {
      if (typeof this.selectRouteMenu === 'function') {
        this.selectRouteMenu(this.menuList);
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';
.MenuItem {
  position: relative;
  width: 80px;
  height: 44px;
  color: #fff;
  &.Selected,
  &:hover {
    background-color: #68aaff;
  }
  .IconMenu {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .IconMenu-icon {
      width: 17px;
      height: 17px;
      margin-bottom: 5px;
    }
    .IconMenu-name {
      font-size: 14px;
    }
  }
  .SubmenuBox {
    background-color: #68aaff;
    padding: 0 20px;
    position: absolute;
    top: 42px;
    z-index: 5;
    height: 0;
    max-height: 0;
    border-radius: 0 0 8px 8px;
    transition: all 0.28s ease-in-out;
    overflow: hidden;
    &.show {
      max-height: 600px;
      height: auto;
    }
    &.scroll {
      overflow-y: auto;
    }
    .Submenu-title {
      width: 560px;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: #78fcf3;
      .like-icon {
        margin-left: 10px;
      }
    }
    .Submenu-list {
      display: flex;
      flex-flow: wrap;
      width: 560px;
      .Submenu-link {
        display: inline-block;
        min-width: 140px;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        color: #fff;
      }
      .like-icon {
        margin-right: 10px;
      }
    }
    .like-icon {
      display: inline-block;
      width: 12px;
      height: 12px;
    }
    .like-icon,
    .Submenu-link-text {
      cursor: pointer;
    }
  }
}
@media screen and (min-width: $bigScreenWidth) {
  .MenuItem {
    width: 112px;
    height: 80px;
    .IconMenu {
      .IconMenu-icon {
        width: 34px;
        height: 34px;
        margin-bottom: 10px;
      }
      .IconMenu-name {
        font-size: 18px;
      }
    }
    .SubmenuBox {
      top: 80px;
      .Submenu-title {
        height: 46px;
        line-height: 46px;
        font-size: 18px;
      }
      .Submenu-list {
        .Submenu-link {
          height: 40px;
          line-height: 40px;
          font-size: 18px;
        }
      }
      .like-icon {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
